import { format, isValid, parseISO } from "date-fns";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PillType } from "../components/controls/Pills";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export function insertItem(array, action) {
  let newArray = array.slice();
  newArray.splice(action.index, 0, action.item);
  return newArray;
}

// needs the index and the item attributes itself
export const updateObjectInArray = (array, action) => {
  return array.map((item, index) => {
    if (index !== action.index) {
      // This isn't the item we care about - keep it as-is
      return item;
    }
    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...action.item,
    };
  });
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};

export const getLastItem = (thePath) =>
  thePath.substring(thePath.lastIndexOf("/") + 1);

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

export const formatDate = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, yyyy");
  }
  return date;
};

export const formatDateWithoutParsing = (date) => {
  return format(date, "LLL dd, yyyy");
};

export const formatDateStandard = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "yyyy-MM-dd");
  }
  return date;
};

export const formatDateWithTime = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, YYY h:mm a");
  }
  return date;
};

export const convertToDefEventPara = (name, value) => {
  return {
    target: {
      name,
      value,
    },
  };
};

export function convertToTwoDecimals(valToConvert, decimals = 2) {
  return parseFloat(valToConvert).toFixed(decimals);
}

export const yesOrNoOptions = [
  { label: "No", value: 1 },
  { label: "Yes", value: 2 },
];

export const userTypeOptions = [
  { value: 0, label: "Employee" },
  { value: 1, label: "Admin" },
];

export const stockUnitOfMeasureOptions = [
  { value: 1, label: "kg" },
  { value: 2, label: "lbs" },
  { value: 3, label: "pieces" },
];

export const productUnitOfMeasureOptions = [
  { value: 1, label: "weight" },
  { value: 2, label: "pieces" },
];

export function convertToCurrencyFormat(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function generateUniqueNumber() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11, so add 1
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const uniqueNumber = `${month}${day}${hours}${minutes}${seconds}`;
  return uniqueNumber.slice(-10); // Ensure it's 10 digits
}

export const isPositiveInteger = (val) => {
  let str = String(val);

  str = str.trim();

  if (!str) {
    return false;
  }

  str = str.replace(/^0+/, "") || "0";
  let n = Math.floor(Number(str));

  return n !== Infinity && String(n) === str && n >= 0;
};

export const orderStatusOptions = [
  { label: "In Progress", value: 1, type: PillType.Error },
  { label: "Pending", value: 2, type: PillType.DarkYellow },
  { label: "Completed", value: 4, type: PillType.Success },
  { label: "Invoiced", value: 3, type: PillType.Gray },
  { label: "Quote", value: 5, type: PillType.Cyan },
  { label: "Non Billable", value: 6, type: PillType.Black },
];

export function convertStatus(status) {
  const statusOption = orderStatusOptions.filter((el) => el.value === status);

  return statusOption.length === 1
    ? { text: statusOption[0].label, type: statusOption[0].type }
    : { text: orderStatusOptions[0].label, type: orderStatusOptions[0].type };
}

export const serviceTypes = [
  { label: "Material", value: 0, type: PillType.LightLime },
  { label: "Labour", value: 1, type: PillType.DarkSky },
  { label: "Work Performed", value: 2, type: PillType.DarkYellow },
];

export function convertServieType(servie) {
  const serviceOption = serviceTypes.filter((el) => el.value === servie);

  return serviceOption.length === 1
    ? { text: serviceOption[0].label, type: serviceOption[0].type }
    : { text: serviceTypes[0].label, type: serviceTypes[0].type };
}
